module.exports = __webpack_public_path__ + "static/media/horseracing-icon.d94a9e1f.webp";